<template>
  <div>
    <transactions-desktop v-if="screenType === 'desktop'"></transactions-desktop>
    <transactions-mobile v-else></transactions-mobile>
  </div>
</template>

<script>
import TransactionsDesktop from "@/components/Pages/Desktop/Dashboard/Transactions/TransactionsDesktop.vue";
import TransactionsMobile from "@/components/Pages/Mobile/Dashboard/Transactions/TransactionsMobile.vue";

export default {
  name: "TransactionsMain",
  components: {TransactionsDesktop, TransactionsMobile},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>